<template>
  <v-footer color="grey lighten-5" padless>
    <v-row justify="center" no-gutters>
      <v-btn
        v-for="link in links"
        :key="link"
        color="black"
        text
        class="my-2"
        :href="link"
      >
        {{ link }}
      </v-btn>
      <v-col class="grey lighten-4 py-4 text-center black--text" cols="12">
        <span
          >&copy; {{ new Date().getFullYear() }} by
          <strong>Angela Sette</strong> | Designed by
          <strong
            ><a href="https://www.sparc.agency" target="_blank" class="link"
              >Sparc Agency</a
            ></strong
          ></span
        >
      </v-col>
    </v-row>
  </v-footer>
</template>

<style lang="scss">
.link {
  color: black !important;
}
</style>

<script>
export default {
  data: () => ({
    links: ["about", "privacy", "terms", "contact"]
  })
};
</script>
